import { DefaultTheme } from 'styled-components'

export const lightTheme: DefaultTheme = {
    toggleBorder: '#FFF',
    background: '#363537',
    colors: {
        body: '#fbfbfb',
        text: '#363537',
        logo: '#FFFFFF'
      },
}